import { gql } from '@apollo/client'

const DISHES_AVAILABLE_FOR_QA_COUNTS_QUERY = gql`
  query dishesAvailableForQaCountsQuery(
    $menuId: ID
    $filters: DishFiltersInput!
  ) {
    dishesAvailableForQaCounts(menuId: $menuId, filters: $filters) {
      userId
      count
    }
  }
`

export default DISHES_AVAILABLE_FOR_QA_COUNTS_QUERY
